<template>
  <div>
    <img src="../../assets/images/reback.png" alt="">
  </div>
</template>

<script>
export default {
  name: "Reback",
  //   props: ["dialogVisable1"],
  data () {
    return {
    }
  },

}
</script>

<style lang="less" scoped>
img {
  margin: 0 15px;
}
</style>
